import { render, staticRenderFns } from "./orderSetting.vue?vue&type=template&id=537d2a4c&scoped=true&"
import script from "./orderSetting.vue?vue&type=script&lang=js&"
export * from "./orderSetting.vue?vue&type=script&lang=js&"
import style0 from "./orderSetting.vue?vue&type=style&index=0&id=537d2a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537d2a4c",
  null
  
)

component.options.__file = "orderSetting.vue"
export default component.exports